<template>
    <div style="text-align: center;line-height: calc(100vh - 200px)">
        <h1>程序员已祭天</h1>
    </div>
</template>

<script>
    export default {
        name: "props"
    }
</script>

<style scoped>

</style>